module.exports = __webpack_public_path__ + "img/Endangered_Animals_bear.6e810058.png";